import os from './data/os'
import browserEngines from './data/browserEngines'
import mobileBrowers from './data/mobileBrowers'
import getDetector from './getDetector'

const Detector = getDetector(os, mobileBrowers, browserEngines)

export default Detector



// WEBPACK FOOTER //
// ./node_modules/ohu-detect/src/index.js